import { select } from "@angular-redux/store";
import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";

import { ComponentSource, ModalType } from "../../models/component-source";
import { RailwayDeparture } from "../../models/RailwayDeparture";
import { RailwayLine } from "../../models/RailwayLine";
import { SharedActions } from "../../shared.actions";
import { SharedService } from "../../services/shared.service";
import { ModalManagerService } from "../../services/modal-manager.service";
import { PlanningBlock } from "../../../pb-screen/models/planning-block/planning-block.interface";
import { MsalService } from "../../../msal";
import { UserFeedbackService } from "../../../services/user-feedback.service";


@Component({
  selector: "rail-planning-modal",
  templateUrl: "./rail-planning-modal.component.html",
})

export class RailPlanningModalComponent implements OnInit {
  public selectedPbs: PlanningBlock[];
  public componentSource = ComponentSource;
  public modalType = ModalType;
  public dateInput: string;
  public lineList: RailwayLine[];
  public departureList: RailwayDeparture[];
  public selectedLine: RailwayLine = null;
  public selectedDeparture: RailwayDeparture;
  public loadingSpinner: boolean = false;
  public rowIndex: number;
  public userId: string;

  @Input() public source: string;
  @select("depotInSelection") public depotInSelection$: Observable<PlanningBlock[]>;
  @select("depotOutSelection") public depotOutSelection$: Observable<PlanningBlock[]>;
  @select("loading") public loading$: Observable<boolean>;

  constructor(
    private readonly sharedActions: SharedActions,
    private readonly sharedService: SharedService,
    private readonly userFeedbackService: UserFeedbackService,
    private readonly modalManager: ModalManagerService,
    private readonly authService: MsalService
  ) {
  }

  public ngOnInit() {
    this.loading$.subscribe((data) => {
      if (!data) {
        this.loadingSpinner = data;
      }
    });
    this.depotInSelection$.subscribe((selectedPlanningBlocks: PlanningBlock[]) => {
      if (this.source === this.componentSource.depotIn) {
        this.selectedPbs = selectedPlanningBlocks;
      }
    });
    this.depotOutSelection$.subscribe((selectedPlanningBlocks: PlanningBlock[]) => {
      if (this.source === this.componentSource.depotOut) {
        this.selectedPbs = selectedPlanningBlocks;
      }
    });


    const account = this.authService.getAccount();
    this.userId = account.username;
    this.dateInput = new Date().toISOString().slice(0, 10);
  }

  public dateInputChanged() {
    this.formatDateForApi();
    if (this.selectedLine) {
      this.sharedService.getRailwayDepartures(this.selectedLine.no, this.formatDateForApi(), this.userId)
        .subscribe((res: RailwayDeparture[]) => {
          this.departureList = res;
          this.selectedDeparture = null;
        });
    }
  }

  public lineSelectionChanged() {
    this.sharedService.getRailwayDepartures(this.selectedLine.no, this.formatDateForApi(), this.userId)
      .subscribe((res: RailwayDeparture[]) => {
        this.departureList = res;
        this.selectedDeparture = null;
      });
  }

  public planAction() {
    const account = this.authService.getAccount();
    this.userId = account.username;

    if (!this.selectedLine) {
      this.userFeedbackService.showWarningMessage("TOASTR_MESSAGES.ERROR.MISSING_TRAIN_LINE");
    } else if (!this.selectedDeparture) {
      this.userFeedbackService.showWarningMessage("TOASTR_MESSAGES.ERROR.MISSING_TRAIN_DEPARTURE");
    } else {
      this.loadingSpinner = true;

      if (this.userId) {
        this.planPbsToTrain(this.userId);
      } else {
        this.userFeedbackService.showErrorMessage("USER_NOT_FOUND");
      }

    }
  }

  public planPbsToTrain(username: string): void {
    this.sharedService.planPbsToTrain(
      this.selectedPbs,
      this.selectedLine.no,
      this.selectedDeparture.entryNo,
      username,
    )
      .subscribe((plannedPbs: PlanningBlock[]) => {
        this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.ALLOCATE_TO_TRAIN");
        this.closeModal();
        this.sharedActions.updatePlanningBlocksDisplayCpl(plannedPbs);
        this.loadingSpinner = false;
      }, _ => {
        this.loadingSpinner = false;
      });
  }

  public closeModal() {
    this.sharedActions.resetModalDomains();
    this.enableUi();
    this.clearFields();
  }

  public clearFields() {
    this.departureList = null;
    this.selectedLine = null;
    this.rowIndex = -1;
  }

  public departureSelected(selectedDeparture, rowIndex) {
    this.rowIndex = rowIndex;
    this.selectedDeparture = selectedDeparture;
  }

  public enableUi() {
    this.sharedActions.setUiState(true);
    this.modalManager.closeModal(this.modalType.rail);
  }

  public formatDateForApi() {
    const dateArray = this.dateInput.split("-");
    return dateArray[1] + "-" + dateArray[2] + "-" + dateArray[0];
  }

}
